import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { since: String }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 15000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  update() {
    const since = new Date(this.sinceValue)
    const mins = Math.round((Date.now() - since.getTime()) / 60000)

    if (mins < 60) {
      this.element.textContent = `${mins}min waiting`
    } else if (mins < 1440) {
      const h = Math.floor(mins / 60)
      const m = mins % 60
      this.element.textContent = m > 0 ? `${h}h ${m}min waiting` : `${h}h waiting`
    } else {
      const d = Math.floor(mins / 1440)
      this.element.textContent = `${d}d waiting`
    }
  }
}
